import { defineStore } from 'pinia'
import Cookies from 'js-cookie'

export const useAppStore = defineStore('app', {
  state: () => ({
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      collapsed: false,
      withoutAnimation: false
    },
    device: 'desktop',
    hasSideEffectLoading: false
  }),

  actions: {
    toggleSideBar() {
      if (this.device === 'mobile') {
        this.sidebar.opened = !this.sidebar.opened
        Cookies.set('sidebarStatus', this.sidebar.opened ? 0 : 1)
      } else {
        this.sidebar.collapsed = !this.sidebar.collapsed
      }
    },
    closeSideBar(withoutAnimation) {
      Cookies.set('sidebarStatus', 1)
      this.sidebar.opened = false
      this.sidebar.withoutAnimation = withoutAnimation
    },
    openSideBar(withoutAnimation) {
      Cookies.set('sidebarStatus', 0)
      this.sidebar.opened = true
      this.sidebar.withoutAnimation = withoutAnimation
    },
    toggleDevice(device) {
      this.device = device
    },
    setSideEffectLoading(status) {
      this.hasSideEffectLoading = status
    }
  }
})
